import React, { Component } from "react";
import DatePicker from "react-date-picker";
import Select from "react-select";
import axios from "axios";
import ReactTable from "react-table";
import LoadingSpinner from "../../components/Input/LoadingSpinner";
import {optionsPagesa} from "../../variables/Modal"
import {menyrePagese} from "../../variables/Modal"
import {kodeProdukte} from "../../variables/Modal"
import { thousands_separators } from "../../components/Methods/Methods";
import HmacSHA256 from "crypto-js/hmac-sha256";
import moment from "moment";
import { CSVLink } from "react-csv";

class RaportPodeTeKthyeraMbrapa extends Component {
  state = {
    PNga: new Date(),
    PDeri: new Date(),
    date: new Date(),
    posts: [],
    NrPod: "",
    dataPosts: [],
    Id: "",
    Perdorues: { value: "True", label: "Te Gjitha" },
    terminal: [],
    data2: [],
    data3: [],
    data3: [{}],
    username: window.UserP.username,
    ProcesorId: "",
    TotTotali: "0",
    TotCmimiBaze:"0",
    KPLeke: "0",
    KPEuro: "0",
    TotShtese: "0",
    TotTakse: "0",
    TotSig: "0",
    TotTvsh: "0",
    selectedOption: null,
    txtAgjensi: true,
    KushPaguan: optionsPagesa[2],
    KodiProduktit: kodeProdukte[4],
    Korrier: { value: "True", label: "Te Gjitha" },
    MenyrePagese: { value: "True", label: "Te Gjitha" },
    Agjensi: window.UserP.agencyId,
    data4: [],
    Destinacion: { value: "True", label: "Te Gjitha" },
    data5: [],
    KodLevizje: { value: "True", label: "Te Gjitha" },
    Dergues: { value: "True", label: "Te Gjitha" },
    data6: [],
    data7: [],
    Pershkrimi: { value: "True", label: "Te Gjitha" },
    data8: [],
    KlienteSubjekte: { value: "True", label: "Te Gjitha" },
    PerdoruesAgjensi: { value: "True", label: "Te Gjitha" },
    loading: false,
  };

  handleClear = () => {
    this.setState({
      date: "",
      PNga: new Date(),
      PDeri: new Date(),
      posts: [{}],
      terminal: [],
    });
  };
  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });
  };
  convertToDropDown = (par) => {
    var ret = [];
    var paramArray = par;

    for (var i in paramArray) {
      var objItem = { value: "", label: "" };
      objItem.value = paramArray[i];
      objItem.label = paramArray[i];
      ret.push(objItem);
    }
    return ret;
  };

  componentDidMount() {
    {
      fetch(window.UserP.url + "POD/KorrieriByAgency", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data2: data }));
    }

    {
      fetch(window.UserP.url + "POD/GetAgjensi", {
        method: "Post",
        headers: {
          Accept: "application/json",
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data4: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetDergues", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data6: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKodeLevizje", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data5: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKodePershkrimi", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data7: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetCity", {
        method: "Post",
        headers: {
          Accept: "application/json",
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data1: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKlienteSubjekte", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data8: data }));
    }
  }
  handleChange = (value) => {
    this.setState({
      PNga: value,
    });
  };

  handleChange1 = (value) => {
    this.setState({
      PDeri: value,
    });
  };

  printfunction = () => {
    var windowName = "";
    var windowUrl = " ";
    var myWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,right=0,bottom=0 margin=0,0,0,0"
    );

    var b = "&nbsp";
    let test = this.state.posts;

    var test5 =
      "&nbsp" +
      "<tr>" +
      "<th >" +
      "Agjensia: " +
      window.UserP.agencyId +
      "<br>" +
      "Terminal:" +
      window.UserP.idProcesori +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "Periudha: " +
      this.state.PNga.toLocaleDateString() +
      "___" +
      this.state.PDeri.toLocaleDateString() +
      "</th>" +
      "<br>" +
      "<br>" +
      "<font face='calibri'" +
      ">" +
      "<br>" +
      "&nbsp" +
      "&nbsp" +
      "<br>" +
      "<br>" +
      "<b>" +
      "   </tr>" +
      "<table border='1' >" +
      "<thead>" +
      "<tr>" +
      "<th class='cell'>" +
      "Nr_POD" +
      "</th>" +
      " <th class='cell'>" +
      "Kod_Levizje" +
      "</th>" +
      "<th class='-cell'>" +
      "Pesha__kg_" +
      "</th>" +
      "<th class='-cell'>" +
      "Pershkrimi" +
      "</th>" +
      "<th class='-cell'>" +
      "Menyre_Pagese" +
      "</th>" +
      "<th class='-cell'>" +
      "Kodi_Produktit" +
      "</th>" +
      "<th class='-cell'>" +
      "Vl.Blerje" +
      "</th>" +
      "<th class='-cell'>" +
      "Mondedhe Blerjeje" +
      "</th>" +
      // "<th class='-cell'>" +
      // "Shtese" +
      // "</th>" +
      // "<th class='-cell'>" +
      // "Takse" +
      // "</th>" +
      // "<th class='-cell'>" +
      // "Vl. Sig" +
      // "</th>" +
      // "<th class='-cell'>" +
      // "Tvsh" +
      // "</th>" +
      // "<th class='-cell'>" +
      // "Cmimi.ZBritje" +
      // "</th>" +
      "<th class='-cell'>" +
      "Totali" +
      "</th>" +
      "<th class='-cell'>" +
      "Data" +
      "</th>" +
      "<th class='-cell'>" +
      "Emri Dergues" +
      "</th>" +
      "<th class='-cell'>" +
      "Emri Marres" +
      "</th>" +
      "  </tr>" +
      "  </thead>";

    for (var i = 0; i < test.length; i++) {
      test5 +=
        "  <tbody>" +
        "<tr class='firstRow'>" +
        "<td class='Nr_POD:-cell'>" +
        test[i].Nr_POD +
        "</td>" +
        " <td class='Kod Levizje:-cell'>" +
        test[i].Kod_Levizje +
        "</td>" +
        " <td class='Pesha__kg_:-cell'>" +
        test[i].Pesha__kg_ +
        "</td>" +
        " <td class='Pershkrimi:-cell'>" +
        test[i].Pershkrimi +
        "</td>" +
        " <td class='Menyre_Pagese:-cell'>" +
        test[i].Menyre_Pagese +
        "</td>" +
        " <td class='Kodi_Produktit:-cell'>" +
        test[i].Kodi_Produktit +
        "</td>" +
        " <td class='Vl.Blerje:-cell'>" +
        test[i].Vlera_Kunder_Pagese +
        "</td>" +
        " <td class='Mondedhe Blerjeje:-cell'>" +
        test[i].Monedha_Kunder_Pagese +
        "</td>" +
        // " <td class='Shtese:-cell'>" +
        // test[i].Shtesa +
        // "</td>" +
        // " <td class='Takse:-cell'>" +
        // test[i].Takse_Karburant_Leke +
        // "</td>" +
        // " <td class='Vl. Sig:-cell'>" +
        // test[i].Vl__Sig_ +
        // "</td>" +
        // " <td class='Tvsh:-cell'>" +
        // test[i].Tvsh +
        // "</td>" +
        // " <td class='Cmimi.ZBritje:-cell'>" +
        // test[i].Cmimi_me_zbritje +
        // "</td>" +
        " <td class='Totali:-cell'>" +
        test[i].Totali +
        "</td>" +
        " <td class='Data:-cell'>" +
        test[i].Data +
        "</td>" +
        " <td class='Data:-cell'>" +
        test[i].Derguesi +
        "</td>" +
        " <td class='Data:-cell'>" +
        test[i].Marresi +
        "</td>" +
        "   </tr>" +
        "&nbsp" +
        "&nbsp" +
        "</tr>";
    }

    test5 +=
      "</table><br>" +
      "Total Blerje LEKE: " +
      this.state.KPLeke +
      Array(46)
        .fill("&nbsp")
        .join("") +
      "Tot.Shtese: " +
      this.state.TotShtese +
      "<br>" +
      "Total Blerje EURO:  " +
      this.state.KPEuro +
      Array(46)
        .fill("&nbsp")
        .join("") +
      "Tot.Takse: " +
     this.state.TotTakse +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.VlSig: " +
      this.state.TotSig +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.Tvsh: " +
      this.state.TotTvsh +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.C.Baze:   " +
      this.state.TotCmimiBaze +
      "<br>" +
      "<b>" +
      Array(82)
        .fill("&nbsp")
        .join("") +
      "Tot.Totali:   " +
      this.state.TotTotali +
      "</tbody></font>";
    myWindow.document.write(test5);

    myWindow.focus();

    myWindow.print();
  };


  handleClick = (e) => {
    const RaportReq = {
      PNga: moment(this.state.PNga).format("MM/DD/YYYY"),
      PDeri: moment(this.state.PDeri).format("MM/DD/YYYY"),
      username: this.state.username,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
      Perdorues: window.UserP.username,
      ProcesorId: window.UserP.idProcesori,
      Agjensi: window.UserP.agencyId,
      PerdoruesAgjensi: this.state.PerdoruesAgjensi.label,
      Terminal: window.UserP.terminalId,
      KodLevizje: this.state.KodLevizje.label,
      Pershkrimi: this.state.Pershkrimi.label,
      KodiProduktit: this.state.KodiProduktit.label,
      KushPaguan: this.state.KushPaguan.label,
      MenyrePagese: this.state.MenyrePagese.label,
      Dergues: this.state.Dergues.label,
      KlienteSubjekte: this.state.KlienteSubjekte.label,
      NrPod: this.state.NrPod,
      Destinacion: this.state.Destinacion.label,
      Korrier: this.state.Korrier.label,
      StatusPodDirection: "Kthyer Mbrapsht",
    };
  
    axios
      .post(window.UserP.url + "POD/LogKthimeMbrapaArkaAgjent", RaportReq)
      .then((response) => {
        this.setState({
          posts: response.data,
        });
        let valueAdded = 0;
          let vleraPakosLeke = 0;
          let vleraPakosEuro = 0;
          let totalLek = 0;
          let totShtese = 0;
          let totTakse = 0;
          let totSig = 0;
          let totTvsh = 0;
          let total = 0;

          for (var i = 0; i < this.state.posts.length; i++) {
            if (this.state.posts[i].Monedha_Kunder_Pagese == "LEKE") {
              vleraPakosLeke += parseFloat(
                this.state.posts[i].Vlera_Kunder_Pagese
              );
            } else {
              vleraPakosEuro += parseFloat(
                this.state.posts[i].Vlera_Kunder_Pagese
              );
            }
            totShtese += parseFloat(this.state.posts[i].Shtesa);
            totTakse += parseFloat(this.state.posts[i].Takse_Karburant_Leke);
            totSig += parseFloat(this.state.posts[i].Vl__Sig_);
            totTvsh += parseFloat(this.state.posts[i].Tvsh);
            valueAdded += parseFloat(this.state.posts[i].Cmimi_me_zbritje);
            total += parseFloat(this.state.posts[i].Totali);
          }

          this.setState({
            KPLeke: thousands_separators(vleraPakosLeke.toFixed(2)),
            KPEuro: thousands_separators(vleraPakosEuro.toFixed(2)),
            TotShtese: thousands_separators(totShtese.toFixed(2)),
            TotTakse: thousands_separators(totTakse.toFixed(2)),
            TotSig: thousands_separators(totSig.toFixed(2)),
            TotTvsh: thousands_separators(totTvsh.toFixed(2)),
            TotCmimiBaze: thousands_separators(valueAdded.toFixed(2)),
            TotTotali: thousands_separators(total.toFixed(2)),
          });
      });
     

  };
  onChangeFunc = (name) => (value) => {
    
    this.setState({
      [name]: value,
    });
  };

  render() {
    const columns = [
      {
        Header: "Nr",

        id: "row",
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: "Nr.POD",
        accessor: "Nr_POD",

        //  Cell: e => <a href={e.value}>{(onClick = this.showModal())}</a>
        Cell: (cell) => (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={() => this.handleClickGjurmo(cell.value)}
          >
            {cell.value}
          </span>
        ),
      },

      {
        Header: "Pershkrimi",
        accessor: "Pershkrimi",
      },
      {
        Header: "Pesha (Kg)",
        accessor: "Pesha__kg_",
      },
      {
        Header: "Kod Levizje",
        accessor: "Kod_Levizje",
      },

      {
        Header: "Kush Paguan",
        accessor: "Kush_Paguan",
      },

      {
        Header: "Shtesa",
        accessor: "Shtesa",
      },

      {
        Header: "Vl.Sig",
        accessor: "Vl__Sig_",
      },
      {
        Header: "Tvsh",
        accessor: "Tvsh",
      },
      {
        Header: "Takse Karburant Leke",
        accessor: "Takse",
      },
      // {
      //   Header: "Koment",
      //   accessor: "Koment",
      // },
      // {
      //   Header: "Vl.CmimiBazeEuro",
      //   accessor: "Vl_CmimBazeEuro",
      // },
      {
        Header: "Cmimi me zbritje",
        accessor: "Cmimi_me_zbritje",
      },
      {
        Header: "Totali",
        accessor: "Totali",
      },
      {
        Header: "Vlera Kunder Pagese",
        accessor: "Vlera_Kunder_Pagese",
      },
      {
        Header: "Monedha Kunder Pagese",
        accessor: "Monedha_Kunder_Pagese",
      },
      {
        Header: "Origjina",
        accessor: "Origjina",
      },

      {
        Header: "Qyteti Destinacion",
        accessor: "Qyteti_Destinacion",
      },
      {
        Header: "Data",
        accessor: "Data",
      },
      {
        Header: "Menyre Pagese",
        accessor: "Menyre_Pagese",
      },
      {
        Header: "Kodi Produktit",
        accessor: "Kodi_Produktit",
      },
      {
        Header: "Kliente Subjekte Dergues",
        accessor: "Kliente_Subjekte_Dergues",
      },
      {
        Header: "Kliente Subjekte Marres",
        accessor: "Kliente_Subjekte_Marres",
      },
      {
        Header: "Korrieri",
        accessor: "Korrieri",
      },
      {
        Header: "Marresi",
        accessor: "Marresi",
      },
      {
        Header: "Agjensia Dorezuese",
        accessor: "Agjensia_Dorezuese",
      },
      {
        Header: "Marresi ne Dorezim",
        accessor: "Marresi_Dorezim",
      },
      {
        Header: "Derguesi",
        accessor: "Derguesi",
      },
    ];

    return (
      <div className="Form2">
        <div className="card card-body bg-light col-md-12">
          <div className="row ">
            <div className="col-md-2">
              <label className="">Nr Pod</label>
            </div>
            <div className="col-md-2">
              <input
                className="form-control input-sm"
                type="text"
                name="NrPod"
                onChange={(e) => this.handleInputChange(e, "NrPod")}
              />
            </div>
            <div className="col-md-2">
              <label>Kthyer Mbrapa nga: </label>
            </div>
            <div className="col-md-2">
              <input
                className="form-control "
                value={this.state.Agjensi}
                type="text"
                //   onChange={e => this.handleInputChange(e, "Agjensi")}
                disabled={this.state.txtAgjensi}
              />
            </div>
            <div className="col-md-2">
              <label>Origjina</label>
            </div>
            <div className="col-md-2">
              <Select
                onChange={this.onChangeFunc("Origjina")}
                options={this.convertToDropDown(this.state.data4)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-2">
              <label className="">Destinacioni</label>
            </div>
            <div className="col-md-2">
              <Select
                onChange={this.onChangeFunc("Destinacion")}
                options={this.convertToDropDown(this.state.data1)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
            <div className="col-md-2">
              <label> Kush Paguan</label>
            </div>
            <div className="col-md-2">
              <Select
                className="custom-Select"
                onChange={this.onChangeFunc("KushPaguan")}
                options={optionsPagesa}
                defaultValue={optionsPagesa[2]}
              />
            </div>
            <div className="col-md-2">
              <label>Kliente Subjekte</label>
            </div>
            <div className="col-md-2">
              <Select
                className="custom-Select"
                //value={this.state.kushPaguan}
                onChange={this.onChangeFunc("KlienteSubjekte")}
                options={this.convertToDropDown(this.state.data8)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-2">
              <label className="">Kodi Levizjes</label>
            </div>
            <div className="col-md-2">
              <Select
                onChange={this.onChangeFunc("KodLevizje")}
                options={this.convertToDropDown(this.state.data5)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
            <div className="col-md-2">
              <label>Kodi Produktit</label>
            </div>
            <div className="col-md-2">
              <Select
                id="3"
                className="custom-Select "
                // value={this.state.kodiProduktit}
                onChange={this.onChangeFunc("KodiProduktit")}
                options={kodeProdukte}
                defaultValue={kodeProdukte[4]}
              />
            </div>
            <div className="col-md-2">
              <label> Menyre Pagese</label>
            </div>
            <div className="col-md-2">
              <Select
                className="custom-Select"
                onChange={this.onChangeFunc("MenyrePagese")}
                options={menyrePagese}
                defaultValue={menyrePagese[2]}
              />
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-2">
              <label className="">Pershkrimi</label>
            </div>
            <div className="col-md-2">
              <Select
                className=""
                // value={this.state.terminal}
                onChange={this.onChangeFunc("Pershkrimi")}
                options={this.convertToDropDown(this.state.data7)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
            <div className="col-md-2">
              <label> Derguesi</label>
            </div>
            <div className="col-md-2">
              <Select
                onChange={this.onChangeFunc("Dergues")}
                options={this.convertToDropDown(this.state.data6)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-3">
              <label className="">Nga</label>
            </div>
            <div className="col-md-3">
              <DatePicker
                locale="en-NZ"
                onChange={this.handleChange}
                value={this.state.PNga}
                name="PNga"
                dateFormat="Pp"
              />
            </div>
            <div className="col-md-3">
              <label className="">Deri</label>
            </div>
            <div className="col-md-3">
              <DatePicker
                locale="en-NZ"
                onChange={this.handleChange1}
                value={this.state.PDeri}
                name="PDeri"
                dateFormat="Pp"
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-3">
              <button
                onClick={() => this.handleClick()}
                className="btn btn-primary "
              >
                <span data-notify="icon" className="pe-7s-search" />
                &nbsp; Kerko
              </button>
              <button
                onClick={() => this.printfunction()}
                className="btn btn-primary float-right "
              >
                <span data-notify="icon" className="pe-7s-print" />
                &nbsp; Printo
              </button>
            </div>
            <div className="col-md-3">
            <CSVLink className="mt-4 float-left" data={this.state.posts}>
              <span data-notify="icon" className="pe-7s-download" />
              &nbsp; Eksporto
            </CSVLink>
            </div>
            
            <div className="col-md-3">
              <button
                className="btn btn-primary float-right"
                // type="submit"
                onClick={this.handleClear}
              >
                <span data-notify="icon" className="pe-7s-trash" />
                &nbsp; Pastro
              </button>
            </div>
          </div>
          {this.state.loading ? (
            <LoadingSpinner />
          ) : (
            <div className="row mt-2">
              <div className="col-md-12 ">
                <ReactTable
                  columns={columns}
                  data={this.state.posts}
                  defaultPageSize={5}
                  className="-striped -highlight mt-4"
                  pageText="Faqe"
                  nextText="Para"
                  rowsText="Rreshta"
                  previousText="Mbrapa"
                  noDataText="Nuk ka te dhena"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default RaportPodeTeKthyeraMbrapa;
